import React, { useState } from "react";
import {
  Box,
  Button,
  TableContainer,
  Paper,
  Table,
  TableRow,
  TableHead,
  TableCell,
  TableBody,
  Tabs,
  Tab,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import HeaderTitle from "../../../components/common/HeaderTitle/HeaderTitle";
import SearchBar from "../../../components/common/SearchBar/SearchBar";

const PriceListHome = ({
  onUploadPriceCatalog,
  onUploadPriceList,
  catalogRecords,
  priceListRecords,
}) => {
  const [activeTab, setActiveTab] = useState(0);
  const [catalogSearch, setCatalogSearch] = useState("");
  const [priceListSearch, setPriceListSearch] = useState("");
  const navigate = useNavigate();

  const filteredCatalogRecords = catalogRecords.filter(
    (item) =>
      item.document_number?.toLowerCase().includes(catalogSearch.toLowerCase()) ||
      item.buyer_name?.toLowerCase().includes(catalogSearch.toLowerCase()) ||
      item.vendor_name?.toLowerCase().includes(catalogSearch.toLowerCase()),
  );

  const filteredPriceListRecords = priceListRecords.filter(
    (item) =>
      item.document_number?.toLowerCase().includes(priceListSearch.toLowerCase()) ||
      item.buyer_name?.toLowerCase().includes(priceListSearch.toLowerCase()) ||
      item.vendor_name?.toLowerCase().includes(priceListSearch.toLowerCase()),
  );

  const handleAction = (record) => {
    navigate("/Buyer_dashboard/price_list/create_quotation", {
      state: { selectedPriceList: record },
    });
  };

  return (
    <Box sx={{ p: 2 }}>
      <Box
        sx={{
          mt: 1,
          mb: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        <HeaderTitle titleText="Price List" />
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Button
            variant="contained"
            size="small"
            sx={{
              fontSize: 15,
              fontFamily:"gilroyBold",
              textTransform: "none",
              px: 1,
              py: 1,
              borderRadius: 1.5,
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
            }}
            onClick={onUploadPriceCatalog}
          >
            Price Catalog
          </Button>
          <Button
            variant="contained"
            size="small"
            sx={{
              fontSize: 15,
              textTransform: "none",
              fontFamily:"gilroyBold",
              px: 1,
              py: 1,
              borderRadius: 1.5,
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
            }}
            onClick={onUploadPriceList}
          >
            Generate Quotation
          </Button>
        </Box>
      </Box>

      <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 1 }}>
        <Tabs value={activeTab} onChange={(_, value) => setActiveTab(value)}>
          <Tab
            label="Price Catalog"
            sx={{ textTransform: "none", fontFamily:"gilroyBold",fontSize: "16px" }}
          />
          <Tab
            label="Quotation"
            sx={{ textTransform: "none",fontFamily:"gilroyBold", fontSize: "16px"}}
          />
        </Tabs>
      </Box>

      {activeTab === 0 && (
        <Box sx={{ mt: "20px", width: "100%", overflowX: "auto" }}>
          <Box sx={{ flex: 1, mb: 2 }}>
            <SearchBar
              value={catalogSearch}
              onChange={(value) => {
                setCatalogSearch(value);
              }}
            />
          </Box>
          <TableContainer
            component={Paper}
            sx={{
              borderRadius: 2,
              boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
            }}
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  {[
                    "Price Catalog Number",
                    "Buyer Name",
                    "Supplier Name",
                    "created_date",
                    "Action",
                  ].map((header, index) => (
                    <TableCell
                      key={index}
                      sx={{
                        fontWeight: 600,
                        fontFamily: "GilroySemiBold",
                        backgroundColor: "#e0e9ee",
                        fontSize: "14px",
                        borderBottom: "1px solid #e2e8f0",
                      }}
                    >
                      {header}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {filteredCatalogRecords.map((item, index) => (
                  <TableRow
                    key={index}
                    sx={{
                      backgroundColor: "white",
                      "&:hover": { backgroundColor: "#f5f5f5" },
                      borderBottom: "1px solid #e2e8f0",
                    }}
                  >
                    <TableCell sx={{ fontFamily: "GilroyMedium", fontSize: "14px" }}>
                      {item.document_number}
                    </TableCell>
                    <TableCell sx={{ fontFamily: "GilroyMedium", fontSize: "14px" }}>
                      {item.buyer_name}
                    </TableCell>
                    <TableCell sx={{ fontFamily: "GilroyMedium", fontSize: "14px" }}>
                      {item.vendor_name}
                    </TableCell>
                    <TableCell sx={{ fontFamily: "GilroyMedium", fontSize: "14px" }}>
                      {item.created_date}
                    </TableCell>
                    <TableCell>
                      <Button
                        variant="outlined"
                        size="medium"
                        sx={{
                          textTransform: "none",
                          fontWeight: 600,
                          borderRadius: 1.5,
                          fontSize: "12px",
                          whiteSpace: "nowrap",
                        }}
                        onClick={() => handleAction(item)}
                      >
                        Create Quotation
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}

                {filteredCatalogRecords.length === 0 && (
                  <TableRow>
                    <TableCell
                      colSpan={5}
                      sx={{
                        fontFamily: "GilroyMedium",
                        fontSize: "14px",
                        textAlign: "center",
                      }}
                    >
                      No price catalog records found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      )}

      {activeTab === 1 && (
        <Box sx={{ mt: "20px", width: "100%", overflowX: "auto" }}>
          <Box sx={{ flex: 1, mb: 2 }}>
            <SearchBar
              value={priceListSearch}
              onChange={(value) => {
                setPriceListSearch(value);
              }}
            />
          </Box>
          <TableContainer
            component={Paper}
            sx={{
              borderRadius: 2,
              boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
            }}
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  {["Price List Number", "Buyer Name", "Supplier Name", "created_date", "Action"].map(
                    (header, index) => (
                      <TableCell
                        key={index}
                        sx={{
                          fontWeight: 600,
                          fontFamily: "GilroySemiBold",
                          backgroundColor: "#e0e9ee",
                          fontSize: "14px",
                          borderBottom: "1px solid #e2e8f0",
                        }}
                      >
                        {header}
                      </TableCell>
                    ),
                  )}
                </TableRow>
              </TableHead>

              <TableBody>
                {filteredPriceListRecords.map((item, index) => (
                  <TableRow
                    key={index}
                    sx={{
                      backgroundColor: "white",
                      "&:hover": { backgroundColor: "#f5f5f5" },
                      borderBottom: "1px solid #e2e8f0",
                    }}
                  >
                    <TableCell sx={{ fontFamily: "GilroyMedium", fontSize: "14px" }}>
                      {item.document_number}
                    </TableCell>
                    <TableCell sx={{ fontFamily: "GilroyMedium", fontSize: "14px" }}>
                      {item.buyer_name}
                    </TableCell>
                    <TableCell sx={{ fontFamily: "GilroyMedium", fontSize: "14px" }}>
                      {item.vendor_name}
                    </TableCell>
                    <TableCell sx={{ fontFamily: "GilroyMedium", fontSize: "14px" }}>
                      {item.created_date}
                    </TableCell>
                    <TableCell>
                      <Button
                        variant="outlined"
                        size="medium"
                        sx={{
                          textTransform: "none",
                          fontWeight: 600,
                          borderRadius: 1.5,
                          fontSize: "12px",
                          whiteSpace: "nowrap",
                        }}
                        onClick={() => handleAction(item)}
                      >
                        Create Quotation
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}

                {filteredPriceListRecords.length === 0 && (
                  <TableRow>
                    <TableCell
                      colSpan={5}
                      sx={{
                        fontFamily: "GilroyMedium",
                        fontSize: "14px",
                        textAlign: "center",
                      }}
                    >
                      No price list records found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      )}
    </Box>
  );
};

export default PriceListHome;
